import AjaxBase from '../../../lib/AjaxBase';

export default class DataService extends AjaxBase {
  static getVerificationCode(data) {
    return super.post(super.URL_PREFIX + "users/verification", data);
  }

  static userLogin(data) {
    return super.get(super.URL_PREFIX + "users/token_by_code", data);
  }

  static getUserToken(code) {
    return super.get(super.URL_PREFIX + `users/token`, { code })
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/LoginPcApp/lib/DataService.js